<template>
  <div class="projetVersion">
    <div v-show='spinning' class="spin">
      <a-spin size="large"  :spinning="spinning"/>
    </div>
    <div class="info">
      <div class="logo">
        <img :src="info.icon">
      </div>
      <div class="text">
        <div class="name">
          {{info.name}}
        </div>
        <div class="desc">
          {{info.desc | isMore}}
        </div>
      </div>
      <div class="btn">
        <a-button size='small' type='primary' @click='toSettingProject'>编辑项目信息</a-button>
      </div>
    </div>
    <div class="main">
      <div class="head">
        <div class="title">
          项目版本管理
        </div>
        <div class="create">
          <a-button type='primary' @click='createNewVersion'>新建版本</a-button>
        </div>
        <div class="search">
          <a-dropdown class='btn sort' :trigger="['click']">
            <a-button>
              <a-icon type="swap" />
              排序
            </a-button>
            <a-menu slot="overlay">
              <a-menu-item v-for='(item, index) in sortList' :key='index' :class='{"act":item.type===sortType}' @click='changeSort(item)'>
                  <a-icon class='icon' type="arrow-down" v-if='sortType===item.type && sortBig'/>
                  <a-icon class='icon' type="arrow-up" v-if='sortType===item.type && !sortBig'/>
                  <a-icon v-if='sortType!==item.type'></a-icon>
                  {{item.name}}
              </a-menu-item>
            </a-menu>
          </a-dropdown>
          <a-dropdown class='btn' :trigger="['click']">
            <a-button >
              <a-icon type="filter" />
              筛选
            </a-button>
            <a-menu class='filter' slot="overlay">
              <a-menu-item v-for='(item, index) in filterList' :key='index' :class='{"act":item.type===filterType}' @click='changeFilter(item)'>
                {{item.name}}
              </a-menu-item>
            </a-menu>
          </a-dropdown>
          <a-input-search class='inp' v-model='searchValue' placeholder='搜索您的项目' allowClear/>
        </div>
      </div>
      <div class="list">
        <div class="item" v-for="(item,index) in finalList" :key="index" :id='"x"+item._id'>
          <div class="itemInfo">
            <div class="name">
              <div class='nameText' v-if='!item.isEdit'>
                {{item.name}}
                <div class="edit" @click="changeEdit(item)">
                  <a-icon type="form" />
                </div>
              </div>
              <a-input size='small' v-if='item.isEdit' v-model='item.name' @blur='blurEdit(item)' v-focus @input='nameEdit(item)'></a-input>
            </div>
            <div class="source">
              {{item.source_name? `版本来源：${item.source_name}` : ''}}
            </div>
            <div class="num">
              {{item.feature_number || 0}}个一级功能,{{item.function_number || 0}}个二级功能
            </div>
            <div class="updateTime">
              更新时间:{{item.hex_update_time | toTime}}
            </div>
            <div class="createTime">
              创建时间:{{item.hex_create_time | toTime}}
            </div>
            <!-- <a-button @click='toFunctionList(item)'>功能列表</a-button>
            <a-button @click='toDemo(item)'>预览demo</a-button> -->
          </div>
          <div class="step">
            <a-steps labelPlacement='vertical'>
              <a-step v-for="(step, indexs) in stageList" :key="indexs" :status='stepStatus(item,indexs)'>
                <template slot="title">
                  {{step.name}}
                </template>
                <span slot="description">
                  <div class="btns">
                    <a-button size='small' v-for='(btn, indexss) in step.btns' :key='indexss' @click="stepClick(btn.type,item)">
                      {{btn.name}}
                    </a-button>
                  </div>
                </span>
              </a-step>
            </a-steps>
          </div>
          <div class="other">
            <div class="top" v-if='item.price'>
              <div class="topItem">
                <div class="price">
                  ¥ {{item.price? item.price*1 : 0}}
                </div>
                <div class="line">
                  |
                </div>
                <div class="day">
                  {{item.work_day*1 || 0}} 天
                </div>
                <div class="status" style='background:none'></div>
              </div>
            </div>
            <div class="top" v-else>
              <div class="topItem">
                <div class="price">
                  ¥ {{item.max_price? item.max_price*1 : 0}}
                </div>
                <div class="line">
                  |
                </div>
                <div class="day">
                  {{item.max_work_day*1 || 0}} 天
                </div>
                <div class="status">max</div>
              </div>
              <div class="topItem">
                <div class="price">
                  ¥ {{item.min_price? item.min_price*1 : 0}}
                </div>
                <div class="line">
                  |
                </div>
                <div class="day">
                  {{item.min_work_day*1 || 0}} 天
                </div>
                <div class="status">min</div>
              </div>
            </div>
            <div class="platform">
              <div class="title">
                平台：
              </div>
              <div class='plats'>
                <a-tooltip>
                  <template slot="title">
                    <span class='plat' v-for="(plat, index) in item.platform" :key="index">
                      {{plat}}
                    </span>
                  </template>
                  <span class='plat' v-for="(plat, index) in item.platform.slice(0,6)" :key="index">
                    {{plat}}<template v-if='item.platform.length>6 && index===5'>...</template>
                  </span>
                </a-tooltip>
              </div>
            </div>
          </div>
          <div class="more">
            <a-dropdown :trigger="['click']">
              <a-icon type="ellipsis" />
              <a-menu slot="overlay">
                <a-menu-item @click='iteration(item)'>
                  迭代
                  <a-icon></a-icon>
                </a-menu-item>
                <a-menu-item :disabled='list.length<2 || !item.is_delete'>
                  <a-popconfirm
                      v-if='list.length>1 && item.is_delete'
                    title="确定要删除这个版本吗?"
                    okText="确定"
                    cancelText="取消"
                    @confirm='deleteVersion(item)'
                  >
                    <a href="#" class='del'>
                      删除
                    </a>
                  </a-popconfirm>
                  <div v-else>
                    删除
                  </div>
                </a-menu-item>
              </a-menu>
            </a-dropdown>
          </div>
        </div>
        <a-empty v-if='!finalList.length' description='没有符合条件的结果'/>
      </div>
    </div>
    <a-modal class='projectVersionModal' :visible='modalShow' :title='modalTitle' okText='确认' cancelText='取消' @ok='okModal' @cancel='cancelModal'>
      <div class="modalList">
        <div class="title">
          请选择你要迭代的版本
        </div>
        <div class="items">
          <div class="item" v-for="(item,index) in list" :key="index" :class="{'active':selectVersion._id === item._id}" @click='selectThisVersion(item)'>
            <div class="radio">
              <img src="../../img/selected.png">
            </div>
            <div class="info">
              <div class="name">
                {{item.name}}
              </div>
              <div class="createTime">
                创建时间:{{item.hex_create_time | toTime}}
              </div>
            </div>
            <div class="platform">
              <div class="title">
                平台：
              </div>
              <div class='plats'>
                <a-tooltip>
                  <template slot="title">
                    <span class='plat' v-for="(plat, index) in item.platform" :key="index">
                      {{plat}}
                    </span>
                  </template>
                  <span class='plat' v-for="(plat, index) in item.platform.slice(0,6)" :key="index">
                    {{plat}}<template v-if='item.platform.length>6 && index===5'>...</template>
                  </span>
                </a-tooltip>
              </div>
            </div>
            <div class="other">
              <div class="top" v-if='item.price'>
                <div class="topItem">
                  <div class="price">
                    ¥ {{item.price? item.price*1 : 0}}
                  </div>
                  <div class="line">
                    |
                  </div>
                  <div class="day">
                    {{item.work_day*1 || 0}} 天
                  </div>
                  <div class="status" style='background:none'></div>
                </div>
              </div>
              <div class="top" v-else>
                <div class="topItem">
                  <div class="price">
                    ¥ {{item.max_price? item.max_price*1 : 0}}
                  </div>
                  <div class="line">
                    |
                  </div>
                  <div class="day">
                    {{item.max_work_day*1 || 0}} 天
                  </div>
                  <div class="status">max</div>
                </div>
                <div class="topItem">
                  <div class="price">
                    ¥ {{item.min_price? item.min_price*1 : 0}}
                  </div>
                  <div class="line">
                    |
                  </div>
                  <div class="day">
                    {{item.min_work_day*1 || 0}} 天
                  </div>
                  <div class="status">min</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
// import mock from './mock.js'
import { stringify } from 'query-string'
export default {
  name: 'projectVersion',
  data () {
    return {
      info: {},
      list: [],
      searchValue: '',
      sortList: [
        { name: '更新时间', type: 'update' },
        { name: '创建时间', type: 'create' }
      ],
      filterList: [
        { name: '全部', type: '' },
        { name: '需求', type: 'carding' },
        { name: '下单', type: 'order' },
        { name: '接单', type: 'taking' },
        { name: '原型流程', type: 'prototype' },
        { name: '开发', type: 'develop' },
        { name: '测试', type: 'test' },
        { name: '验收', type: 'finish' }
      ],
      sortType: 'update',
      sortBig: true,
      filterType: '',
      modalShow: false,
      modalTitle: '开发迭代版本',
      selectVersion: {},
      stageList: [
        {
          name: '需求',
          btns: [
            {
              name: '梳理需求',
              type: 'carding'
            }
          ]
        }, {
          name: '下单',
          btns: [
            {
              name: '支付',
              type: 'pay'
            },
            {
              name: '报价单',
              type: 'order'
            }
          ]
        }, {
          name: '接单'
        }, {
          name: '原型/流程',
          btns: [
            {
              name: '查看',
              type: 'prototype'
            }
          ]
        }, {
          name: '开发',
          btns: [
            {
              name: '看进度',
              type: 'develop'
            }
          ]
        }, {
          name: '测试',
          btns: [
            {
              name: 'bug工单',
              type: 'test'
            }
          ]
        }, {
          name: '验收',
          btns: [
            {
              name: '查看验收',
              type: 'finish'
            }, {
              name: '服务器配置',
              type: 'server'
            }
          ]
        }
      ],
      lastName: '',
      lastMaxName: '',
      stageArr: ['carding', 'order', 'taking', 'prototype', 'develop', 'test', 'finish'],
      spinning: true
    }
  },
  computed: {
    finalList () {
      let final = []
      final = this.list.filter(item => item.name.indexOf(this.searchValue) !== -1)
      if (this.filterType) {
        final = final.filter(item => item.status === this.filterType)
      }
      switch (this.sortType) {
        case 'create':
          if (this.sortBig) {
            final = final.sort((a, b) => b.hex_create_time - a.hex_create_time)
          } else {
            final = final.sort((a, b) => a.hex_create_time - b.hex_create_time)
          }
          break
        default:
          if (this.sortBig) {
            final = final.sort((a, b) => b.hex_update_time - a.hex_update_time)
          } else {
            final = final.sort((a, b) => a.hex_update_time - b.hex_update_time)
          }
          break
      }
      return final
    }
  },
  methods: {
    init () {
      this.$post('/wuwei/api/version/list', { project_id: this.$route.query.project_id }).then(result => {
        this.info = result.project
        this.list = result.list
        this.toStageNum()
        this.changeIsDelete()
        this.spinning = false
      }).catch(error => {
        this.spinning = false
        console.log(error)
      })
    },
    toStageNum () {
      this.list = this.list.sort((a, b) => b.hex_update_time - a.hex_update_time)
      this.list.map(item => {
        item.stageNum = this.stageArr.indexOf(item.status)
      })
    },
    changeIsDelete () {
      this.list.map(item => {
        if (this.list.find(items => items.source === item._id) || item.stageNum > 0) {
          this.$set(item, 'is_delete', false)
        } else {
          this.$set(item, 'is_delete', true)
        }
      })
    },
    toSettingProject () {
      // 编辑项目
      this.sendLogger({
        action: 'put',
        type: 'project'
      })
      window.location.href = `${process.env.NEXT_URL}?${stringify({
        ...this.$route.query,
        url: window.location.href
      })}`
    },
    changeSort (item) {
      if (this.sortType === item.type) {
        this.sortBig = !this.sortBig
        return
      }
      this.sortType = item.type
    },
    changeFilter (item) {
      this.filterType = item.type
    },
    createNewVersion () {
      this.modalShow = true
      this.selectVersion = this.list[0]
    },
    okModal () {
      this.iteration(this.selectVersion)
      this.modalShow = false
    },
    cancelModal () {
      this.modalShow = false
    },
    changeEdit (item) {
      this.lastName = item.name
      this.$set(item, 'isEdit', !item.isEdit)
    },
    blurEdit (item) {
      if (item.name === this.lastName) {
        this.$set(item, 'isEdit', false)
        return
      }
      if (!item.name) {
        this.$message.warn('请输入版本名称')
        item.name = this.lastName
        this.$set(item, 'isEdit', false)
        return
      } else if (this.list.find(items => items.name === item.name && items._id !== item._id)) {
        this.$message.warn('版本名称重复')
        item.name = this.lastName
        this.$set(item, 'isEdit', false)
        return
      }
      this.$post('/wuwei/api/version/updatename', { project_id: this.$route.query.project_id, version_id: item._id, name: item.name }).then(result => {
        this.$set(item, 'hex_update_time', new Date().getTime())
        this.list.map(items => {
          if (items.source === item._id) {
            this.$set(items, 'source_name', item.name)
          }
        })
      }).catch(reject => {
        this.$message.warn('修改失败,请检查网络连接情况并重试')
        item.name = this.lastName
      })
      this.$set(item, 'isEdit', false)
    },
    nameEdit (item) {
      if (item.name.length > 10) {
        item.name = this.lastMaxName
        return
      }
      this.lastMaxName = item.name
    },
    toFunctionList (item) {
      // TODO:跳转功能列表页面
      console.log('toFunctionList', item)
    },
    toDemo (item) {
      // TODO:跳转demo页面
      console.log('toDemo', item)
    },
    iteration (item) {
      // TODO:迭代版本的接口,item是迭代的对象,name是迭代的默认名字
      this.spinning = true
      let name = this.nextName()
      this.$post('/wuwei/api/version/clone', { project_id: this.$route.query.project_id, version_id: item._id, name }).then(result => {
        this.list.push(result.data)
        this.$nextTick(() => {
          let dom = document.querySelector(`#x${result.data._id}`)
          if (dom && dom.scrollIntoView) {
            dom.scrollIntoView()
            this.changeEdit(result.data)
            this.toStageNum()
            this.changeIsDelete()
            this.spinning = false
          }
        })
      }).catch(error => {
        this.spinning = false
        console.log(error)
      })
    },
    nextName () {
      let names = []
      let keyWord = '新建版本'
      let final = ''
      this.list.map(item => {
        if (item.name.substr(0, 4) === keyWord && !isNaN(item.name.slice(4) * 1)) {
          names.push(item.name.slice(4) * 1)
        }
      })
      names.sort((a, b) => b - a)
      for (let i = 1; i < names.length + 2; i++) {
        if (names.indexOf(i) === -1) {
          final = keyWord + i
          break
        }
      }
      return final
    },
    deleteVersion (item) {
      this.$post('/wuwei/api/version/delete', { project_id: this.$route.query.project_id, version_id: item._id }).then(result => {
        if (result.info === '200') {
          this.list.map(items => {
            if (items.source === item._id) {
              items.source_name += '(已删除)'
            }
          })
          let idx = this.list.findIndex(items => item._id === items._id)
          this.list.splice(idx, 1)
          this.changeIsDelete()
        }
      })
    },
    selectThisVersion (item) {
      this.selectVersion = item
    },
    stepClick (type, item) {
      // TODO:这里是流程的各个按钮的点击
      // carding:梳理需求,pay:支付,order:报价单,prototype:原型/流程/查看,develop:开发/看进度,test:bug工单,finish:查看验收,server:'服务器配置'
      const query = {
        ...this.$route.query,
        version_id: item._id
      }
      switch (type) {
        case 'pay':
          this.$router.push({
            path: '/pay',
            query
          })
          break
        case 'order':
          query.url = window.location.href
          window.open(`${process.env.QUOTATION_URL}?${stringify(query)}`, '_blank')
          break
        case 'prototype':
          break
        case 'develop':
          break
        case 'test':
          break
        case 'finish':
          break
        case 'server':
          break
        default:
          query.v = true
          this.$router.push({
            path: '/inner/home',
            query
          })
          break
      }
    },
    stepStatus (step, indexs) {
      if (step.stageNum > indexs) {
        return 'finish'
      } else if (step.stageNum === indexs) {
        return 'process'
      }
    }
  },
  filters: {
    isMore (str) {
      if (!str) {
        return
      }
      if (str.length > 40) {
        return str.substr(0, 40) + '...'
      }
      return str
    }
  },
  directives: {
    focus: {
      inserted: function (el) {
        el.focus()
      }
    }
  },
  created () {
    this.init()
  }
}
</script>

<style lang="less">
.projetVersion{
  background: #F7F7F7;
  padding: 20px;
  width: 100%;
  height: calc(100vh - 64px);
  display: flex;
  flex-direction: column;
  position: relative;
  .spin{
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: 100;
    background: rgba(247,247,247,.5);
    .ant-spin{
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%,-50%);
    }
  }
  .info{
    background: #fff;
    display: flex;
    padding: 20px;
    flex-shrink: 0;
    .logo{
      width: 55px;
      height: 55px;
      border-radius: 8px;
      overflow: hidden;
      flex-shrink: 0;
      img{
        max-width: 100%;
        max-height: 100%;
      }
    }
    .text{
      margin-left: 20px;
      flex-grow: 1;
      .name{
        font-weight: bold;
        font-size: 16px;
        line-height: 24px;
      }
      .desc{
        font-size: 14px;
        color: rgba(0,0,0,.45);
      }
    }
    .btn {
      flex-shrink: 0;
      margin-left: 20px;
    }
  }
  .main{
    flex-grow: 1;
    height: 1px;
    display: flex;
    flex-direction: column;
    .head{
      display: flex;
      padding: 16px 0;
      flex-shrink: 0;
      .title{
        font-size: 16px;
        line-height: 24px;
        padding: 4px 0;
        font-weight: bold;
        flex-shrink: 0;
      }
      .create{
        margin-left: 24px;
        flex-grow: 1;
      }
      .search{
        flex-shrink: 0;
        display: flex;
        .btn{
          margin-right: 24px;
          color: rgba(0,0,0,.65);
          span{
            margin-left: 4px;
          }
          &.sort{
            i{
              transform: rotate(90deg);
            }
          }
        }
        .inp{
          min-width: 285px;
        }
      }
    }
    .list{
      flex-grow: 1;
      height: 1px;
      overflow-y: scroll;
      position: relative;
      .item{
        background: #fff;
        margin-bottom: 12px;
        padding: 20px;
        display: flex;
        position: relative;
        .itemInfo{
          flex-shrink: 0;
          width: 180px;
          .name{
            font-size: 16px;
            font-weight: bold;
            line-height: 26px;
            margin-bottom: 2px;
            .nameText{
              width: max-content;
              max-width: 100%;
              position: relative;
              padding-right: 14px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              &:hover .edit{
                display: block;
              }
              .edit{
                cursor: pointer;
                display: none;
                width: 10px;
                height: 10px;
                font-size: 10px;
                position: absolute;
                right: 0px;
                top: -5px;
              }
            }
            input{
              box-sizing: border-box;
            }
          }
          .source{
            font-size: 12px;
            color: rgba(0,0,0,.45);
            line-height: 20px;
            height: 40px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
          }
          .num{
            font-size: 12px;
            color: rgba(0,0,0,.65);
            line-height: 20px;
          }
          .updateTime,.createTime{
            font-size: 12px;
            line-height: 20px;
            color: rgba(0,0,0,.45);
          }
        }
        .step{
          display: flex;
          flex-grow: 1;
          margin-left: 40px;
          width: 1px;
          .ant-steps{
            overflow-x: auto;
            overflow-y: hidden;
            .ant-steps-item{
              .ant-steps-item-content{
                .ant-steps-item-title{
                  font-size: 12px;
                  line-height: 20px;
                  font-weight: 500;
                  margin-bottom: 12px;
                }
                .btns{
                  button{
                    display: block;
                    margin: 0 auto 4px;
                  }
                }
              }
            }
            .ant-steps-item-finish,.ant-steps-item-process{
              .ant-steps-item-title{
                color: #FC8830;
              }
            }
          }
        }
        .other{
          flex-shrink: 0;
          margin-right: 32px;
          margin-left: 50px;
          width: 260px;
          .top{
            font-size: 16px;
            line-height: 24px;
            font-weight: bold;
            height: 48px;
            width: 100%;
            .topItem{
              margin-bottom: 4px;
              display: flex;
              width: 100%;
              .price{
                flex-grow: 1;
                text-align: left;
                max-width: 122px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              }
              .day{
                width: 60px;
                text-align: right;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              }
              .line{
                color: #DBDBDB;
                margin: 0 12px;
              }
              .status{
                font-size: 12px;
                line-height: 12px;
                color: rgba(0,0,0,.25);
                background: #F5F5F5;
                border-radius: 4px;
                height: 16px;
                padding: 2px;
                margin:4px 0 0 12px;
                min-width: 30px;
              }
            }
          }
          .platform{
            display: flex;
            margin-top: 30px;
            .title{
              font-size: 14px;
              line-height: 22px;
              font-weight: bold;
              flex-shrink: 0;
            }
            .plats{
              flex-grow: 1;
              width: 1px;
              span{
                flex-wrap: wrap;
                display: flex;
              }
              .plat{
                font-size: 12px;
                margin-right: 15px;
                color: rgba(0,0,0,.65);
              }
            }
          }
        }
        .more{
          position: absolute;
          right: 10px;
          top: 12px;
          font-size: 18px;
          i{
            padding: 2px;
            border-radius: 50%;
            color: #575757;
          }
          .ant-dropdown-open{
            background: #EDEDED;
          }
        }
      }
      .ant-empty{
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
      }
    }
  }
}
.projectVersionModal{
  width: 800px !important;
  height: 80vh !important;
  .ant-modal-content{
    height: 100%;
    display: flex;
    flex-direction: column;
    .ant-modal-body{
      padding: 0 24px 24px;
      background: #F7F7F7;
      flex-grow: 1;
      display: flex;
      .modalList{
        width: 100%;
        display: flex;
        flex-direction: column;
        .title{
          font-size: 14px;
          line-height: 22px;
          color: rgba(0,0,0,.45);
          padding: 8px 0;
          flex-shrink: 0;
        }
        .items{
          flex-grow: 1;
          height: 1px;
          padding: 4px;
          overflow-y: scroll;
          .item{
            cursor: pointer;
            border-radius: 4px;
            overflow: hidden;
            background: #fff;
            margin-bottom: 10px;
            display: flex;
            box-sizing: border-box;
            padding: 12px 0;
            .radio{
              flex-shrink: 0;
              width: 20px;
              height: 20px;
              border: 1px solid #f5f5f5;
              border-radius: 50%;
              margin: auto 20px auto 20px;
              img{
                width: 100%;
                height: 100%;
                display: none;
              }
            }
            .info{
              flex-shrink: 0;
              margin: auto 0;
              .name{
                font-size: 14px;
                font-weight: bold;
                line-height: 22px;
              }
              .createTime{
                font-size: 12px;
                line-height: 20px;
                color: rgba(0,0,0,.45);
              }
            }
            .platform{
              display: flex;
              flex-grow: 1;
              margin: auto 24px;
              .title{
                font-size: 14px;
                line-height: 22px;
                font-weight: bold;
                color: #000;
                padding: 0;
              }
              .plats{
                flex-grow: 1;
                width: 1px;
                span{
                  flex-wrap: wrap;
                  display: flex;
                }
                .plat{
                  font-size: 12px;
                  margin-right: 15px;
                  color: rgba(0,0,0,.65);
                }
              }
            }
            .other{
              flex-shrink: 0;
              margin-right: 12px;
              .top{
                font-size: 16px;
                line-height: 24px;
                font-weight: bold;
                height: 48px;
                width: 100%;
                .topItem{
                  margin-bottom: 4px;
                  display: flex;
                  width: 100%;
                  .price{
                    flex-grow: 1;
                    text-align: right;
                    max-width: 122px;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                  }
                  .day{
                    width: 60px;
                    text-align: right;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                  }
                  .line{
                    color: #DBDBDB;
                    margin: 0 12px;
                  }
                  .status{
                    font-size: 12px;
                    line-height: 12px;
                    color: rgba(0,0,0,.25);
                    background: #F5F5F5;
                    border-radius: 4px;
                    height: 16px;
                    padding: 2px;
                    margin:4px 0 0 12px;
                    min-width: 30px;
                  }
                }
              }
            }
          }
          .active{
            box-shadow: 0 0 0 1px #FC8830;
            .radio{
              border: none;
              img{
                display: block;
              }
            }
          }
        }
      }
    }
  }
}
.ant-dropdown{
  .ant-dropdown-menu{
    padding: 0;
    .act{
      color: #FA883D;
      background: #FEF2D6;
    }
    .del{
      color: #F5222D;
    }
  }
  .filter{
    text-align: center;
  }
}
</style>
